import {
  Box,
  CircularProgress,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Typography,
} from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { useQuery } from 'react-query';
import Zoom from 'react-medium-image-zoom';
import 'react-medium-image-zoom/dist/styles.css';
import { useMemo, useState } from 'react';
import { getEventiFotoByIdEvento } from '../api/getEventiFoto';
import { EventPhotoType } from '../enum/EventPhotoType';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useAuth } from '../components/auth/AuthProvider';
import { Navbar } from '../components/Navbar';
import { ErrorContent } from '../components/ErrorContent';

const photoCategories = [
  { value: EventPhotoType.DDT, label: 'Documento di Trasporto' },
  { value: EventPhotoType.MERCE_DANNEGGIATA, label: 'Merce Danneggiata' },
];

export default function EventPhotos() {
  const [photoCategory, setPhotoCategory] = useState<string>(EventPhotoType.DDT);

  const params = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { token, logout } = useAuth();
  const idEvento = params.id;

  const { data, isLoading, error } = useQuery(
    ['eventPhotos', idEvento],
    async () => getEventiFotoByIdEvento(idEvento || '', token),
    {
      refetchOnWindowFocus: false,
      enabled: !!idEvento,
    },
  );

  const imageData = useMemo(() => {
    if (!data) return [];
    return data.filter((photo) => photo.type === photoCategory);
  }, [data, photoCategory]);

  if (!idEvento || idEvento === '') {
    navigate('/not-found');
    return null;
  }

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
        <CircularProgress />
      </Box>
    );
  }

  if (error || !data) {
    return (
      <>
        <Navbar onLogout={logout} />
        <Box p={3}>
          <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
            <Typography variant="h5" component="h1">
              Foto Evento
            </Typography>
          </Box>
          <ErrorContent />
        </Box>
      </>
    );
  }

  return (
    <>
      <Navbar onLogout={logout} />
      <Box p={3}>
        <Box display="flex" alignItems="center" mb={3}>
          <IconButton onClick={() => navigate(-1)} sx={{ mr: 2 }}>
            <ArrowBackIcon />
          </IconButton>
          <Typography variant="h5" component="h1">
            Foto Evento {idEvento}
          </Typography>
        </Box>
        <Paper sx={{ p: 2, minHeight: '100vh', width: '100%', marginTop: 2 }}>
          <FormControl variant="standard" sx={{ m: 1, minWidth: 200 }}>
            <InputLabel id="demo-simple-select-standard-label">Categoria Foto</InputLabel>
            <Select
              value={photoCategory}
              variant="filled"
              onChange={(e) => setPhotoCategory(e.target.value)}
              label="Age"
              sx={{ width: 200 }}
            >
              {photoCategories.map((category) => {
                return (
                  <MenuItem key={category.value} value={category.value}>
                    {category.label}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
          <Box flexGrow={1} sx={{ marginTop: 2 }}>
            <Grid container columns={{ xs: 6, sm: 8, md: 12 }} alignItems="center" justifyContent="center">
              {imageData.map((photoObject, i) => (
                <Grid item xs={12} sm={6} md={6} key={i}>
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      padding: 1,
                    }}
                  >
                    <Zoom>
                      <img
                        style={{ maxWidth: 220, maxHeight: 220, objectFit: 'cover' }}
                        src={`data:image/png;base64,${photoObject.base64Image}`}
                        alt="evento"
                      />
                    </Zoom>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Box>
        </Paper>
      </Box>
    </>
  );
}
